import React from 'react';
import './Page.css';

function TermsAndConditions() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: December 2024</p>

        <section className="page-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the ExtraByte platform, you agree to be bound 
            by these Terms and Conditions. If you do not agree to these terms, please do not 
            use our services. These terms are governed by the laws of India.
          </p>
        </section>

        <section className="page-section">
          <h2>2. Course Enrollment</h2>
          <p>
            When you enroll in a course, you agree to:
          </p>
          <ul>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the confidentiality of your account credentials</li>
            <li>Complete the course projects according to the guidelines provided</li>
            <li>Not share course materials with unauthorized individuals</li>
            <li>Comply with Indian copyright and intellectual property laws</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>3. Payment Terms</h2>
          <p>
            All course fees must be paid in full before gaining access to course materials. 
            We accept payments through UPI, Credit/Debit Cards, Net Banking, and other 
            Indian payment methods. All prices are listed in Indian Rupees (₹). Prices are 
            subject to change, but enrolled students will not be affected by price increases.
          </p>
        </section>

        <section className="page-section">
          <h2>4. Certificate Issuance</h2>
          <p>
            Certificates are issued upon successful completion of all course requirements, 
            including project submissions and assessments. Certificates are digital, can be 
            verified through our platform, and are recognized by employers across India.
          </p>
        </section>

        <section className="page-section">
          <h2>5. Intellectual Property</h2>
          <p>
            All course materials, including but not limited to videos, documents, and 
            assignments, are the intellectual property of ExtraByte. Students 
            are granted a limited license to use these materials for personal learning 
            purposes only. Any unauthorized distribution violates Indian copyright laws.
          </p>
        </section>

        <section className="page-section">
          <h2>6. User Conduct</h2>
          <p>
            Users agree not to:
          </p>
          <ul>
            <li>Engage in any form of plagiarism or academic dishonesty</li>
            <li>Share login credentials with others</li>
            <li>Attempt to hack, disrupt, or compromise the platform</li>
            <li>Upload malicious content or viruses</li>
            <li>Use the platform for any illegal purposes under Indian law</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>7. Limitation of Liability</h2>
          <p>
            ExtraByte shall not be liable for any indirect, incidental, special, 
            or consequential damages arising from the use of our services. Our total 
            liability shall not exceed the amount paid for the course enrollment.
          </p>
        </section>

        <section className="page-section">
          <h2>8. Modifications to Terms</h2>
          <p>
            We reserve the right to modify these Terms and Conditions at any time. 
            Continued use of the platform after changes constitutes acceptance of the 
            modified terms. We will notify users of significant changes via email.
          </p>
        </section>

        <section className="page-section">
          <h2>9. Governing Law and Jurisdiction</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance 
            with the laws of India. Any disputes shall be subject to the exclusive 
            jurisdiction of courts in Bangalore, Karnataka, India.
          </p>
        </section>

        <section className="page-section">
          <h2>10. Contact Information</h2>
          <p>
            For questions about these Terms and Conditions, please contact us through our 
            Contact Us page or email us at care@extrabyte.in.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsAndConditions;
